module.exports = __webpack_public_path__ + "01c6c283b11bb9bd358a6b4f34355ea2.pdf";